<template>
  <v-dialog-old ref="dialog" id="multiEdit">
    <fieldset style=" height: 155px;overflow: visible">
      <legend>Массовое редактирование</legend>
      <form>
        <table class="grid">
          <tr>
            <td colspan="2">
                    <input type="text" class="large" readonly :value="ids.length | pluralize('', '$ врач', '$ врача', '$ врачей')">
            </td>
          </tr>
          <tr>
            <td width="35%">
              <label>Поле</label>
              <v-select
                  v-model="purpose"
                  :options="options"
              ></v-select>
            </td>
            <td v-if="purpose !=='delete'">
              <label>Значение</label>
                              <input v-if="purpose === null" type="text" value="" class="large" readonly disabled>
                              <input v-if="purpose === 'price'" type="text" v-model="resValue" class="large" style="text-align: right" v-units.literal="`руб`" />

              <v-select v-if="!this.clinics.length && (purpose === 'addClinic' || purpose==='deleteClinic') && selectedClinic === null"
                  @select="selectClinic"
                   v-model="selectedClinic"
                  :options="foundClinics"
                  @search-change="findClinics"
                  placeholder="Поиск клиник..."
              >
                      <template v-slot="{ option }">
                        <div class="textarea" style="width: 250px ;">
                          <span>{{ option.text }}</span>
                          &nbsp;&nbsp;&nbsp;
                          <span v-if="purpose === 'addClinic' && option.networkName !== null" class="label bg-red">
                                                          {{ option.networkName }}
                                                      </span><br>
                          <small>{{ option.address }}</small>
                        </div>
                      </template>

              </v-select>
              <v-select v-if="this.clinics.length && (purpose === 'addClinic' || purpose==='deleteClinic')"
                        v-model="resValue"
                        :options="clinics"
                        label="name"
                        placeholder="Выбор клиник..."
              />

              <div v-if="!this.clinics.length && (purpose === 'addClinic' || purpose==='deleteClinic') && selectedClinic !== null">
                <div class="text-ellipsis" style="width: 92%;    max-width: 95%;height: 20px;display: inline-block;">{{selectedClinic.text}}</div>
                <button
                    style="display: inline-block;"
                    type="button"
                        class="resetBtn small redHover" tooltip="Удалить"
                        @click.prevent="selectedClinic=null">
                  <i class="fas fa-trash"></i>
                </button>
              </div>
            </td>
          </tr>
        </table>
      </form>
    </fieldset>
    <footer>
      <v-loading-component v-if="purpose !=='delete'" @click="update">
        <template slot-scope="{ loadingClass }">
          <button :class="['green', loadingClass]" :disabled="disableButton">Применить</button>
        </template>
      </v-loading-component>
      <v-loading-component @click="updateAndReset">
        <template slot-scope="{ loadingClass }">
          <button :class="['green', loadingClass]" :disabled="disableButton">Применить и сбросить</button>
        </template>
      </v-loading-component>
    </footer>
  </v-dialog-old>
</template>

<script>
import Vue from "vue";
import {mapState} from "vuex";

export default {
  props: {
    clinics: {
      type: Array,
      required: false,
      default: () => []
    },
  },
  data() {
    return {
      ids: [],
      purpose: null,
      resValue: '',
      selectedClinic: null,
      foundClinics: [],
      disableButton: false,
    }
  },
  computed: {
    ...mapState({
      currentUser: state => state.currentUser,
    }),
    options() {
        if(this.currentUser.role === 'admin'){
          return [
            { value: null, text: '' },
            { value: 'price', text: 'Стоимость приема' },
            { value: 'addClinic', text: 'Добавить место приема' },
            { value: 'deleteClinic', text: 'Удалить место приема' }
          ]
        }
      if(this.currentUser.role === 'clinics'){
        return [
          { value: null, text: '' },
          { value: 'price', text: 'Стоимость приема' },
          { value: 'delete', text: 'Удалить' }
        ]
      }
      if(this.currentUser.role === 'network'){
        return [
          { value: null, text: '' },
          { value: 'price', text: 'Стоимость приема' },
          { value: 'addClinic', text: 'Добавить место приема' },
          { value: 'deleteClinic', text: 'Удалить место приема' },
          { value: 'delete', text: 'Удалить' }
        ]
      }
    }
  },
  methods: {
    show: function (idsSelected) {
      this.ids = idsSelected;
      this.purpose = null;
      this.resValue = '';
      this.selectedClinic = null;
      this.foundClinics = [];
      this.$refs.dialog.show();
    },
    selectClinic: function (payload) {
      this.resValue = payload.id
      this.selectedClinic = payload
    },
    findClinicByName: function (name) {
      return this.axios.post('/clinicsAutocomplete', {
        q: name, filter: {}
      });
    },
      findClinicByNameFromDoctorIds: function (name) {
          return this.axios.post('doctors/getClinicsByDoctorIds', {
              ids: this.ids,
              q: name,
          });
      },
    findClinics: function (query) {
      if (query.length>2){
        if(this.purpose==='deleteClinic'){
            this.findClinicByNameFromDoctorIds(query).then(res => {
                this.foundClinics = res.data
            })
        }else {
            this.findClinicByName(query).then(res => {
                this.foundClinics = res.data.suggestions.map(item => {
                    return {
                        id: item.data.id,
                        account_id: item.data.account_id,
                        text: item.data.name,
                        cityName: item.data.cityName,
                        networkName: item.data.networkName,
                        address: item.data.address,
                        children: item.data.children,
                    }
                })
            })
        }
      } else {
        this.foundClinics = [];
      }
    },
    update(btn) {
      if (this.disableButton) {
        return;
      }
      this.disableButton = true;
      btn.startLoadingAnimation();

      return this.axios.post('doctors/multiEdit', {
        ids: this.ids,
        field: this.purpose,
        value: this.resValue,
      }).catch((err) => {
        btn.stopLoadingAnimation();
        this.disableButton = false;
        alert(err.message)
      })
          .then((resp) => {
            btn.stopLoadingAnimation();
            this.disableButton = false;

            if(resp !== undefined){
              this.$refs.dialog.hide();
              this.$parent.$refs.table.update();
            }
          })
    },

    updateAndReset(btn) {
      if (this.disableButton) {
        return;
      }
      this.update(btn)
      this.$parent.multiEditSelectedIds = [];
    },
  },
  watch: {
    purpose (n) {
      this.resValue = ''
      this.selectedClinic = null;
      this.foundClinics = [];
      if(n ==='deleteClinic' && !this.clinics.length){
        this.axios.post('doctors/getClinicsByDoctorIds', {ids: this.ids}).then((resp)=>{
            this.foundClinics = resp.data
        })
      }
    },
  }
}
</script>

<style lang="scss">
#multiEdit {
  width: 1000px !important;
  overflow: visible !important;
}
#multiEdit .multiselect__single {
  padding-top: 5px !important;
}
#multiEdit .multiselect__select {
  height: 32px !important;
}
#multiEdit .multiselect__tags {
  height: 32px!important;
}
#multiEditBody {
  overflow: visible !important;
}
</style>
